import React, { useState } from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import frLocale from "date-fns/locale/fr";
import TextFieldMUI from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker as DatePickerMUI } from "@mui/x-date-pickers/DatePicker";
import add from "date-fns/add";

function DatePicker({
  methods,
  label,
  name,
  required,
  noValidDateMessage,
  variant,
  defaultValue,
  minDate,
  maxDate,
}) {
  const {
    control,
    formState: { errors },
  } = methods;
  const [error, setError] = useState(null);
  return (
    <React.Fragment>
      <Controller
        name={name}
        control={control}
        rules={{
          required,
          validate: () => (error ? noValidDateMessage : null),
        }}
        defaultValue={defaultValue}
        render={({ field, fieldState }) => (
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={frLocale}>
            <DatePickerMUI
              {...field}
              minDate={minDate}
              maxDate={maxDate}
              value={field.value}
              label={label}
              inputFormat="dd/MM/yyyy"
              mask={"__/__/____"}
              onError={(error) => {
                setError(error);
              }}
              renderInput={(params) => (
                <TextFieldMUI
                  {...params}
                  helperText={
                    errors?.hasOwnProperty(name) && errors[name].message
                      ? errors[name].message
                      : " "
                  }
                  error={fieldState.invalid}
                  required={!!required}
                  variant={variant}
                  fullWidth
                />
              )}
            />
          </LocalizationProvider>
        )}
      />
    </React.Fragment>
  );
}

DatePicker.defaultProps = {
  label: "Date",
  name: "date",
  required: "Merci de saisir votre date",
  noValidDateMessage: "Merci de saisir une date correcte",
  variant: "outlined",
  defaultValue: new Date(),
  minDate: new Date(),
  maxDate: add(new Date(), { years: 1 }),
};

DatePicker.propTypes = {
  /**
   * methods du useForm()
   */
  methods: PropTypes.instanceOf(Object),
  /**
   * Label du champ
   */
  label: PropTypes.string,
  /**
   * Name du tag HTML input
   */
  name: PropTypes.string,
  /**
   * Message d'erreur si le champ est requis
   */
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /**
   * Message d'erreur si date non valide
   */
  noValidDateMessage: PropTypes.string,
  /**
   * The variant to use
   * 'filled'
   * | 'outlined'
   * | 'standard'
   */
  variant: PropTypes.string,
  /**
   * Valeur par défaut du champ
   */
  defaultValue: PropTypes.instanceOf(Date),
  /**
   * Date minimale
   */
  minDate: PropTypes.instanceOf(Date),
  /**
   * Date maximale
   */
  maxDate: PropTypes.instanceOf(Date),
};

export default DatePicker;
